import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';

import { layoutClasses } from '../classes';

// ----------------------------------------------------------------------

export type LayoutSectionProps = {
  sx?: SxProps<Theme>;
  children?: React.ReactNode;
  footerSection?: React.ReactNode;
  headerSection?: React.ReactNode;
  sidebarSection?: React.ReactNode;
};

export function LayoutSection({ sx, children, footerSection, headerSection, sidebarSection }: LayoutSectionProps) {
  return (
    <Box id="root__layout" className={layoutClasses.root} sx={sx}>
      {sidebarSection}
      <Box display="flex" flex="1 1 auto" flexDirection="column">
        {headerSection}
        {children}
        {footerSection}
      </Box>
    </Box>
  );
}
